<template>
  <div class="flex p-8">
    <div id="addchatbot-container" class="sm:w-1/2 w-full">
      <div class="vx-row">
        <div
          v-if="!isProPlan"
          style="
            border-radius: 0.5rem;
            background: rgba(255, 255, 255, 0.3);
            backdrop-filter: blur(1px);
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 5555;
          "
        >
          <div class="relative">
            <div class="upgrade-plan-pro w-full">
              <div class="vx-col mx-auto w-3/4 sm:w-full md:w-1/2 mb-base">
                <vx-card class="p-2">
                  <p class="text-center">{{ $t("ChatpagePlanPro") }}</p>
                  <vs-button
                    :to="{ name: 'page-plans' }"
                    class="w-full mt-6"
                    color="success"
                    type="filled"
                    >{{ $t("MigrateNow") }}</vs-button
                  >
                </vx-card>
              </div>
            </div>
          </div>
        </div>
        <div id="chatbot-form" class="vx-col w-full mb-2">
          <label class="vs-input--label">{{ $t("ChatpageTitle") }}</label>
          <vx-input-group class="mb-base">
            <vs-input
              :maxlength="titleMaxLength"
              v-model="title"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="title"
              class="w-full"
            />

            <template slot="append">
              <div class="append-text bg-grey">
                <span v-text="titleMaxLength - title.length"></span>
              </div>
            </template>
          </vx-input-group>
          <label class="vs-input--label">{{ $t("ChatpageDescription") }}</label>

          <vx-input-group class="mb-base">
            <vs-textarea
              class="rounded-r-none h-auto"
              :maxlength="descriptionMaxLength"
              v-model="description"
              v-validate="'required'"
              name="messagedescription"
              data-vv-validate-on="blur"
            />
            <template slot="append">
              <div class="append-text bg-grey">
                <span v-text="descriptionMaxLength - description.length"></span>
              </div>
            </template>
          </vx-input-group>

          <div>
            <label for="urlchatpage" class="vs-input--label">{{
              $t("ChatpageLink")
            }}</label>
            <vx-input-group class="mb-base" label="First Name">
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span>https://chatpag.es/</span>
                </div>
              </template>

              <vs-input
                v-validate="'required'"
                data-vv-validate-on="blur"
                v-model="pageName"
                id="urlchatpage"
                name="urlchatpage"
              />
              <span class="text-danger text-sm">{{
                errors.first("urlchatpage")
              }}</span>
            </vx-input-group>
          </div>

          <div class="vx-row mb-6 hidden">
            <div class="vx-col w-full">
              <vs-input
                name="metatitle"
                class="w-full"
                :label="$t('MetaTitle')"
                v-model="metaTitle"
              />
            </div>
          </div>

          <div class="vx-row mb-6 hidden">
            <div class="vx-col w-full">
              <vs-input
                name="metadescription"
                class="w-full"
                :label="$t('metaDescription')"
                v-model="metaDescription"
              />
            </div>
          </div>

          <vs-collapse type="margin">
            <vs-collapse-item class="mt-4 px-2" id="cardslinks">
              <div slot="header">
                <div class="flex items-end">
                  <feather-icon
                    icon="LinkIcon"
                    class="mr-2"
                    svgClasses="w-5 h-5"
                  />
                  <span class="leading-none font-medium">Cards e Links</span>
                </div>
                <div class="flex w-full mt-5">
                  <vs-button
                    class="w-full mr-10"
                    color="success"
                    type="border"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="newCard = true"
                    >{{ $t("CreateCardChatpage") }}</vs-button
                  >
                </div>
              </div>
              <!-- Novo card -->
              <div v-show="newCard">
                <vx-card class="my-4">
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <label class="vs-input--label"
                        >Escolha uma imagem para o seu card</label
                      >
                      <div class="flex items-center mb-2">
                        <div id="linkFileNew">
                          <feather-icon
                            v-if="imageCard === null"
                            icon="ImageIcon"
                            class="text-gray"
                            svgClasses="w-16 h-16"
                          />
                          <img
                            v-if="imageCard !== null"
                            :src="imageCard"
                            style="
                              width: 59px;
                              height: 59px;
                              background: rgb(195, 195, 195);
                            "
                          />
                        </div>
                        <feather-icon
                          v-if="imageCard !== null"
                          @click="removeImageCard('new')"
                          icon="TrashIcon"
                          class="p-2"
                          svgClasses="w-6 h-6 text-danger"
                        />
                        <avatar-cropper
                          :uploadHandler="uploadImageCard"
                          @changed="changeFileCard"
                          trigger="#linkFileNew"
                          :labels="label"
                        />
                      </div>
                    </div>
                    <div class="vx-col w-full">
                      <label class="vs-input--label">{{
                        $t("LinkTitle")
                      }}</label>
                      <vx-input-group class="mb-2">
                        <vs-input
                          :maxlength="cardTitleMaxLength"
                          v-model="cardTitle"
                          v-validate="'required'"
                          data-vv-validate-on="blur"
                          name="cardTitle"
                          class="w-full"
                        />
                        <template slot="append">
                          <div class="append-text bg-grey">
                            <span
                              v-text="cardTitleMaxLength - cardTitle.length"
                            ></span>
                          </div>
                        </template>
                      </vx-input-group>
                    </div>
                    <div class="vx-col w-full">
                      <label class="vs-input--label">Link</label>
                      <vs-input
                        v-model="cardLink"
                        v-validate="'required'"
                        data-vv-validate-on="blur"
                        name="cardLink"
                        class="w-full"
                      />
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full text-right">
                      <br />
                      <vs-button
                        @click="addCard"
                        color="success"
                        icon-pack="feather"
                        icon="icon-check"
                        class="w-full"
                        :disabled="!validateFormCard"
                        >{{ $t("SaveCardChatpage") }}</vs-button
                      >
                    </div>
                  </div>
                </vx-card>
              </div>
              <draggable v-model="linksList">
                <div v-for="(item, index) in linksList" :key="index">
                  <vx-card class="my-6 shadow-xs">
                    <div slot="no-body">
                      <div class="flex">
                        <div
                          class="cursor-move flex item-center self-stretch border-solid border-grey-light border-0 border-r p-4"
                        >
                          <feather-icon icon="MoveIcon" svgClasses="w-4 h-4" />
                        </div>

                        <div class="w-full p-3">
                          <!-- Editar card -->
                          <div v-if="editLink === index">
                            <div class="vx-row w-full my-3 m-0">
                              <!-- Imagem -->
                              <div class="vx-col flex items-center w-full p-0">
                                <div id="linkFile">
                                  <img
                                    v-if="item.img"
                                    :src="item.img"
                                    style="
                                      width: 59px;
                                      height: 59px;
                                      background: rgb(195, 195, 195);
                                    "
                                  />
                                  <feather-icon
                                    v-else
                                    icon="ImageIcon"
                                    class="text-gray"
                                    svgClasses="w-16 h-16"
                                  />
                                </div>
                                <feather-icon
                                  v-if="item.img"
                                  @click="removeImageCard('edit')"
                                  icon="TrashIcon"
                                  class="p-2"
                                  svgClasses="w-6 h-6 text-danger"
                                />
                                <avatar-cropper
                                  :uploadHandler="uploadImageCardEdit"
                                  @changed="changeFileCardEdit"
                                  trigger="#linkFile"
                                  id="avatarCropperEdit"
                                  :labels="label"
                                />
                              </div>
                              <!-- Titulo e Link -->
                              <div class="vx-col w-full mt-3 p-0">
                                <label class="vs-input--label">{{
                                  $t("ChatpageTitle")
                                }}</label>
                                <vx-input-group class="mb-2">
                                  <vs-input
                                    :maxlength="cardTitleMaxLength"
                                    v-model="item.title"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                                    name="titleLink"
                                    class="w-full"
                                  />

                                  <template slot="append">
                                    <div class="append-text bg-grey">
                                      <span
                                        v-text="
                                          cardTitleMaxLength - item.title.length
                                        "
                                      ></span>
                                    </div>
                                  </template>
                                </vx-input-group>
                              </div>
                              <div class="vx-col w-full p-0">
                                <label class="vs-input--label">Link</label>
                                <vs-input
                                  v-model="item.link"
                                  v-validate="'required'"
                                  data-vv-validate-on="blur"
                                  name="link"
                                  class="w-full mb-2"
                                />
                              </div>
                            </div>
                            <!-- Botões salvar e cancelar -->
                            <div class="vx-row w-full m-0">
                              <div class="vx-col w-full p-0">
                                <vs-button
                                  :disabled="
                                    !(
                                      item.title.length > 0 &&
                                      item.link.length > 0
                                    )
                                  "
                                  class="w-full mt-3"
                                  color="success"
                                  @click="saveCard(index)"
                                  >{{ $t("Save") }}</vs-button
                                >
                              </div>
                              <div class="vx-col w-full p-0">
                                <vs-button
                                  :disabled="
                                    !(
                                      item.title.length > 0 &&
                                      item.link.length > 0
                                    )
                                  "
                                  class="w-full mt-2 mb-3"
                                  color="success"
                                  type="border"
                                  @click="editLink = null"
                                  >{{ $t("Cancel") }}</vs-button
                                >
                              </div>
                            </div>
                          </div>
                          <!-- Exibir card -->
                          <div
                            class="w-full flex justify-center"
                            v-if="editLink !== index"
                          >
                            <div class="vx-row w-full">
                              <div class="vx-col w-full">
                                <img
                                  class="mt-3"
                                  v-if="item.img"
                                  style="
                                    width: 59px;
                                    height: 59px;
                                    background: rgb(195, 195, 195);
                                  "
                                  :src="item.img"
                                />
                              </div>
                              <div class="vx-col w-full">
                                <h4 class="my-3 break-words">
                                  {{ item.title }}
                                </h4>
                              </div>
                              <div class="vx-col w-full">
                                <label class="vs-input--label p-0 text-grey"
                                  >Link:</label
                                >
                                <div class="truncate w-48 md:w-56 lg:w-64">
                                  {{ item.link }}
                                </div>
                              </div>
                              <!-- Botão editar e excluir -->
                              <div class="flex w-full justify-end mt-3">
                                <feather-icon
                                  @click="editLink = index"
                                  icon="EditIcon"
                                  class="p-2 text-success"
                                  svgClasses="w-6 h-6"
                                />
                                <feather-icon
                                  @click="openConfirmDeleteLinkCard(index)"
                                  icon="TrashIcon"
                                  class="p-2"
                                  svgClasses="w-6 h-6 text-danger"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </draggable>
            </vs-collapse-item>
            <vs-collapse-item class="px-2">
              <div slot="header">
                <div class="flex items-end">
                  <feather-icon
                    icon="AtSignIcon"
                    class="mr-2"
                    svgClasses="w-5 h-5"
                  />
                  <span class="leading-none font-medium">{{
                    $t("SocialNetwork")
                  }}</span>
                </div>
              </div>
              <vx-input-group class="mb-base">
                <template slot="prepend">
                  <div class="prepend-text bg-grey">
                    <span>https://facebook.com/</span>
                  </div>
                </template>

                <vs-input
                  v-model="FacebookUrl"
                  @blur="validateSocialURL($event, 'facebook')"
                />
              </vx-input-group>

              <vx-input-group class="mb-base">
                <template slot="prepend">
                  <div class="prepend-text bg-grey">
                    <span>https://instagram.com/</span>
                  </div>
                </template>

                <vs-input
                  v-model="InstagramUrl"
                  @blur="validateSocialURL($event, 'instagram')"
                />
              </vx-input-group>

              <vx-input-group class="mb-base">
                <template slot="prepend">
                  <div class="prepend-text bg-grey">
                    <span>https://linkedin.com/</span>
                  </div>
                </template>

                <vs-input
                  v-model="LinkedinUrl"
                  @blur="validateSocialURL($event, 'linkedin')"
                />
              </vx-input-group>

              <vx-input-group class="mb-base">
                <template slot="prepend">
                  <div class="prepend-text bg-grey">
                    <span>https://twitter.com/</span>
                  </div>
                </template>

                <vs-input
                  v-model="TwitterUrl"
                  @blur="validateSocialURL($event, 'twitter')"
                />
              </vx-input-group>

              <vx-input-group class="mb-base">
                <template slot="prepend">
                  <div class="prepend-text bg-grey">
                    <span>https://youtube.com/</span>
                  </div>
                </template>

                <vs-input
                  v-model="YoutubeUrl"
                  @blur="validateSocialURL($event, 'youtube')"
                />
              </vx-input-group>
            </vs-collapse-item>
          </vs-collapse>

          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button
                id="button-submit-chatpage"
                class="mr-3 mb-2 w-full"
                color="success"
                @click="submitChatPage"
                :disabled="!validateForm"
                >{{ $t("CreateChatPage") }}</vs-button
              >
            </div>
          </div>
        </div>
      </div>
      <vs-button
        class="sm:hidden preview-btn-chatpage transform rotate-90"
        @click="previewChatpage = true"
        color="primary"
        type="gradient"
        icon="icon-eye"
        icon-pack="feather"
        >Preview</vs-button
      >
      <vs-popup
        :title="$t('ChatpagePreview')"
        :active.sync="previewChatpage"
        id="preview-chatpage"
      >
        <div class="vx-col w-full" v-if="previewChatpage">
          <div id="chatbot-example" class="vx-col w-full chatbot-example">
            <iframe
              id="chatpage-iframe"
              src="https://chatpag.es/preview"
              style="
                pointer-events: all;
                background: none;
                border: 0px;
                float: right;
                width: 100%;
                height: 100%;
                max-width: 415px;
                margin: 0px;
                padding: 0px;
                min-height: 0px;
                bottom: 0px;
                right: 0px;
              "
            ></iframe>
          </div>
        </div>
      </vs-popup>
    </div>
    <div
      class="vx-col w-full hidden flex-wrap justify-center sm:flex sm:w-1/2 mb-2 ml-8"
    >
      <h5 class="mb-5 w-full text-center" id="chatbot-ex">
        {{ $t("ChatpagePreview") }}
      </h5>
      <div id="chatbot-example" class="vx-col w-full chatbot-example">
        <iframe
          id="chatpage-iframe"
          src="https://chatpag.es/preview"
          style="
            pointer-events: all;
            background: none;
            border: 0px;
            float: right;
            width: 100%;
            height: 100%;
            max-width: 415px;
            margin: 0px;
            padding: 0px;
            min-height: 0px;
            bottom: 0px;
            right: 0px;
          "
        ></iframe>
      </div>
    </div>
    <!--div class="vx-col hidden w-full sm:flex sm:w-1/2 mb-2 p-4 fixed-preview">
    <div class="w-full">
      <h3 class="mb-5 mt-5" id="chatbot-ex">{{$t('ChatpagePreview')}}</h3>
          <div id="chatbot-example" class="vx-col w-full">
            <iframe
              id="chatpage-iframe"
              src="https://chatpag.es/preview"
              style="pointer-events: all; background: none; border: 0px; float: right; width: 100%; height: 100%; max-width:415px; margin: 0px; padding: 0px; min-height: 0px; bottom: 0px; right: 0px;"
            ></iframe>
          </div>
    </div>
    </div-->
  </div>
</template>

<script>
import Prism from "vue-prism-component";
import vSelect from "vue-select";
import draggable from "vuedraggable";
import AvatarCropper from "vue-avatar-cropper";

export default {
  props: {
    value: {
      type: Number,
    },
  },
  data() {
    return {
      previewChatpage: false,
      display: "",
      idCard: "",
      label: {
        submit: this.$t("Crop"),
        cancel: this.$t("Cancel"),
      },
      imageCard: null,
      cardTitle: "",
      cardLink: "",
      cardTitleMaxLength: 200,
      newCard: false,
      editLink: null,
      linksList: [],
      id: "",
      title: "",
      titleMaxLength: 42,
      description: "",
      descriptionMaxLength: 240,
      pageName: "",
      metaTitle: "",
      metaDescription: "",
      FacebookUrl: "",
      InstagramUrl: "",
      LinkedinUrl: "",
      TwitterUrl: "",
      YoutubeUrl: "",
      WhatsappUrl: "",
      color: "#002f8e",
    };
  },
  computed: {
    validateFormCard() {
      return this.cardTitle != "" && this.cardLink != "";
    },
    validateForm() {
      return !this.errors.any() && this.title != "" && this.pageName != "";
    },
    accPlanData() {
      return this.$store.state.acc.current_acc.accPlan;
    },
    chatData() {
      return this.$store.state.chatbotManagement.current_chatbot;
    },
    isProPlan() {
      return this.$store.state.acc.current_acc.accPlan.plan.planParameters
        .numChatPage
        ? this.$store.state.acc.current_acc.accPlan.plan.planParameters
            .numChatPage > 0
        : false;
    },
  },
  methods: {
    removeImageCard(card) {
      if (card === "edit") this.linksList[this.editLink].img = null;
      if (card === "new") this.imageCard = null;
    },
    uploadImageCard: function (file) {
      var self = this;
      var photo = file;
      if (photo) {
        var url = photo.getCroppedCanvas().toDataURL();
        self.imageCard = url;
      }
    },
    uploadImageCardEdit: function (file) {
      var self = this;
      if (file) {
        var url = file.getCroppedCanvas().toDataURL();
        self.linksList[this.editLink].img = url;
      }
    },
    validateFile(file) {
      let acceptedFormat = ["image/jpeg", "image/jpg", "image/png"];
      if (acceptedFormat.indexOf(file.type) !== -1) {
        if (file.size < 800000) {
          this.display = "flex";
        } else {
          this.display = "none";
          this.$vs.notify({
            title: this.$t("UnexpectedError"),
            text: this.$t("AvatarUploadExceedsSize", ["800 kb"]),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right",
            time: 4000,
          });
        }
      } else {
        this.display = "none";
        this.$vs.notify({
          title: this.$t("InvalidFormat"),
          text: this.$t("AcceptedFormatAvatar"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-right",
          time: 4000,
        });
      }
    },
    changeFileCard(file) {
      if (file) {
        this.validateFile(file);
        document.querySelector(".avatar-cropper").style.display = this.display;
      }
    },
    changeFileCardEdit(file) {
      if (file) {
        this.validateFile(file);
        document.querySelector("#avatarCropperEdit").style.display =
          this.display;
      }
    },
    openConfirmDeleteLinkCard(index) {
      this.idCard = index;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("ConfirmDeleteOfX", ["Card"]),
        text: this.$t("ConfirmDeletedPermanentlyX", [this.$t("TheCard")]),
        accept: this.acceptAlertDeleteLinkCard,
        acceptText: this.$t("Delete"),
        cancelText: this.$t("Cancel"),
      });
    },
    acceptAlertDeleteLinkCard() {
      this.linksList.splice(this.idCard, 1);

      this.$vs.notify({
        color: "danger",
        title: "Card " + this.$t("Deleted"),
        text: this.$t("TheCard") + " " + this.$t("DeletedSuccessfuly"),
        position: "top-right",
        time: 4000,
      });
    },
    saveCard(index) {
      if (!this.linksList[index].img)
        this.linksList[index].img =
          this.imageCard != null ? this.imageCard : null;
      this.editLink = null;
      //this.submitChatPage();
    },
    addCard() {
      let newElm = {
        title: this.cardTitle,
        link: this.cardLink,
        img: this.imageCard != null ? this.imageCard : null,
      };
      this.linksList = [newElm].concat(this.linksList);
      this.newCard = false;
    },
    urlSlang(str) {
      str = String(str).toString();
      str = str.replace(" ", "-");
      //str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      const swaps = {
        0: ["°", "₀", "۰", "０"],
        1: ["¹", "₁", "۱", "１"],
        2: ["²", "₂", "۲", "２"],
        3: ["³", "₃", "۳", "３"],
        4: ["⁴", "₄", "۴", "٤", "４"],
        5: ["⁵", "₅", "۵", "٥", "５"],
        6: ["⁶", "₆", "۶", "٦", "６"],
        7: ["⁷", "₇", "۷", "７"],
        8: ["⁸", "₈", "۸", "８"],
        9: ["⁹", "₉", "۹", "９"],
        a: [
          "à",
          "á",
          "ả",
          "ã",
          "ạ",
          "ă",
          "ắ",
          "ằ",
          "ẳ",
          "ẵ",
          "ặ",
          "â",
          "ấ",
          "ầ",
          "ẩ",
          "ẫ",
          "ậ",
          "ā",
          "ą",
          "å",
          "α",
          "ά",
          "ἀ",
          "ἁ",
          "ἂ",
          "ἃ",
          "ἄ",
          "ἅ",
          "ἆ",
          "ἇ",
          "ᾀ",
          "ᾁ",
          "ᾂ",
          "ᾃ",
          "ᾄ",
          "ᾅ",
          "ᾆ",
          "ᾇ",
          "ὰ",
          "ά",
          "ᾰ",
          "ᾱ",
          "ᾲ",
          "ᾳ",
          "ᾴ",
          "ᾶ",
          "ᾷ",
          "а",
          "أ",
          "အ",
          "ာ",
          "ါ",
          "ǻ",
          "ǎ",
          "ª",
          "ა",
          "अ",
          "ا",
          "ａ",
          "ä",
        ],
        b: ["б", "β", "ب", "ဗ", "ბ", "ｂ"],
        c: ["ç", "ć", "č", "ĉ", "ċ", "ｃ"],
        d: [
          "ď",
          "ð",
          "đ",
          "ƌ",
          "ȡ",
          "ɖ",
          "ɗ",
          "ᵭ",
          "ᶁ",
          "ᶑ",
          "д",
          "δ",
          "د",
          "ض",
          "ဍ",
          "ဒ",
          "დ",
          "ｄ",
        ],
        e: [
          "é",
          "è",
          "ẻ",
          "ẽ",
          "ẹ",
          "ê",
          "ế",
          "ề",
          "ể",
          "ễ",
          "ệ",
          "ë",
          "ē",
          "ę",
          "ě",
          "ĕ",
          "ė",
          "ε",
          "έ",
          "ἐ",
          "ἑ",
          "ἒ",
          "ἓ",
          "ἔ",
          "ἕ",
          "ὲ",
          "έ",
          "е",
          "ё",
          "э",
          "є",
          "ə",
          "ဧ",
          "ေ",
          "ဲ",
          "ე",
          "ए",
          "إ",
          "ئ",
          "ｅ",
        ],
        f: ["ф", "φ", "ف", "ƒ", "ფ", "ｆ"],
        g: ["ĝ", "ğ", "ġ", "ģ", "г", "ґ", "γ", "ဂ", "გ", "گ", "ｇ"],
        h: ["ĥ", "ħ", "η", "ή", "ح", "ه", "ဟ", "ှ", "ჰ", "ｈ"],
        i: [
          "í",
          "ì",
          "ỉ",
          "ĩ",
          "ị",
          "î",
          "ï",
          "ī",
          "ĭ",
          "į",
          "ı",
          "ι",
          "ί",
          "ϊ",
          "ΐ",
          "ἰ",
          "ἱ",
          "ἲ",
          "ἳ",
          "ἴ",
          "ἵ",
          "ἶ",
          "ἷ",
          "ὶ",
          "ί",
          "ῐ",
          "ῑ",
          "ῒ",
          "ΐ",
          "ῖ",
          "ῗ",
          "і",
          "ї",
          "и",
          "ဣ",
          "ိ",
          "ီ",
          "ည်",
          "ǐ",
          "ი",
          "इ",
          "ی",
          "ｉ",
        ],
        j: ["ĵ", "ј", "Ј", "ჯ", "ج", "ｊ"],
        k: ["ķ", "ĸ", "к", "κ", "Ķ", "ق", "ك", "က", "კ", "ქ", "ک", "ｋ"],
        l: ["ł", "ľ", "ĺ", "ļ", "ŀ", "л", "λ", "ل", "လ", "ლ", "ｌ"],
        m: ["м", "μ", "م", "မ", "მ", "ｍ"],
        n: ["ñ", "ń", "ň", "ņ", "ŉ", "ŋ", "ν", "н", "ن", "န", "ნ", "ｎ"],
        o: [
          "ó",
          "ò",
          "ỏ",
          "õ",
          "ọ",
          "ô",
          "ố",
          "ồ",
          "ổ",
          "ỗ",
          "ộ",
          "ơ",
          "ớ",
          "ờ",
          "ở",
          "ỡ",
          "ợ",
          "ø",
          "ō",
          "ő",
          "ŏ",
          "ο",
          "ὀ",
          "ὁ",
          "ὂ",
          "ὃ",
          "ὄ",
          "ὅ",
          "ὸ",
          "ό",
          "о",
          "و",
          "θ",
          "ို",
          "ǒ",
          "ǿ",
          "º",
          "ო",
          "ओ",
          "ｏ",
          "ö",
        ],
        p: ["п", "π", "ပ", "პ", "پ", "ｐ"],
        q: ["ყ", "ｑ"],
        r: ["ŕ", "ř", "ŗ", "р", "ρ", "ر", "რ", "ｒ"],
        s: ["ś", "š", "ş", "с", "σ", "ș", "ς", "س", "ص", "စ", "ſ", "ს", "ｓ"],
        t: ["ť", "ţ", "т", "τ", "ț", "ت", "ط", "ဋ", "တ", "ŧ", "თ", "ტ", "ｔ"],
        u: [
          "ú",
          "ù",
          "ủ",
          "ũ",
          "ụ",
          "ư",
          "ứ",
          "ừ",
          "ử",
          "ữ",
          "ự",
          "û",
          "ū",
          "ů",
          "ű",
          "ŭ",
          "ų",
          "µ",
          "у",
          "ဉ",
          "ု",
          "ူ",
          "ǔ",
          "ǖ",
          "ǘ",
          "ǚ",
          "ǜ",
          "უ",
          "उ",
          "ｕ",
          "ў",
          "ü",
        ],
        v: ["в", "ვ", "ϐ", "ｖ"],
        w: ["ŵ", "ω", "ώ", "ဝ", "ွ", "ｗ"],
        x: ["χ", "ξ", "ｘ"],
        y: [
          "ý",
          "ỳ",
          "ỷ",
          "ỹ",
          "ỵ",
          "ÿ",
          "ŷ",
          "й",
          "ы",
          "υ",
          "ϋ",
          "ύ",
          "ΰ",
          "ي",
          "ယ",
          "ｙ",
        ],
        z: ["ź", "ž", "ż", "з", "ζ", "ز", "ဇ", "ზ", "ｚ"],
        aa: ["ع", "आ", "آ"],
        ae: ["æ", "ǽ"],
        ai: ["ऐ"],
        ch: ["ч", "ჩ", "ჭ", "چ"],
        dj: ["ђ", "đ"],
        dz: ["џ", "ძ"],
        ei: ["ऍ"],
        gh: ["غ", "ღ"],
        ii: ["ई"],
        ij: ["ĳ"],
        kh: ["х", "خ", "ხ"],
        lj: ["љ"],
        nj: ["њ"],
        oe: ["ö", "œ", "ؤ"],
        oi: ["ऑ"],
        oii: ["ऒ"],
        ps: ["ψ"],
        sh: ["ш", "შ", "ش"],
        shch: ["щ"],
        ss: ["ß"],
        sx: ["ŝ"],
        th: ["þ", "ϑ", "ث", "ذ", "ظ"],
        ts: ["ц", "ც", "წ"],
        ue: ["ü"],
        uu: ["ऊ"],
        ya: ["я"],
        yu: ["ю"],
        zh: ["ж", "ჟ", "ژ"],
        "(c)": ["©"],
        A: [
          "Á",
          "À",
          "Ả",
          "Ã",
          "Ạ",
          "Ă",
          "Ắ",
          "Ằ",
          "Ẳ",
          "Ẵ",
          "Ặ",
          "Â",
          "Ấ",
          "Ầ",
          "Ẩ",
          "Ẫ",
          "Ậ",
          "Å",
          "Ā",
          "Ą",
          "Α",
          "Ά",
          "Ἀ",
          "Ἁ",
          "Ἂ",
          "Ἃ",
          "Ἄ",
          "Ἅ",
          "Ἆ",
          "Ἇ",
          "ᾈ",
          "ᾉ",
          "ᾊ",
          "ᾋ",
          "ᾌ",
          "ᾍ",
          "ᾎ",
          "ᾏ",
          "Ᾰ",
          "Ᾱ",
          "Ὰ",
          "Ά",
          "ᾼ",
          "А",
          "Ǻ",
          "Ǎ",
          "Ａ",
          "Ä",
        ],
        B: ["Б", "Β", "ब", "Ｂ"],
        C: ["Ç", "Ć", "Č", "Ĉ", "Ċ", "Ｃ"],
        D: ["Ď", "Ð", "Đ", "Ɖ", "Ɗ", "Ƌ", "ᴅ", "ᴆ", "Д", "Δ", "Ｄ"],
        E: [
          "É",
          "È",
          "Ẻ",
          "Ẽ",
          "Ẹ",
          "Ê",
          "Ế",
          "Ề",
          "Ể",
          "Ễ",
          "Ệ",
          "Ë",
          "Ē",
          "Ę",
          "Ě",
          "Ĕ",
          "Ė",
          "Ε",
          "Έ",
          "Ἐ",
          "Ἑ",
          "Ἒ",
          "Ἓ",
          "Ἔ",
          "Ἕ",
          "Έ",
          "Ὲ",
          "Е",
          "Ё",
          "Э",
          "Є",
          "Ə",
          "Ｅ",
        ],
        F: ["Ф", "Φ", "Ｆ"],
        G: ["Ğ", "Ġ", "Ģ", "Г", "Ґ", "Γ", "Ｇ"],
        H: ["Η", "Ή", "Ħ", "Ｈ"],
        I: [
          "Í",
          "Ì",
          "Ỉ",
          "Ĩ",
          "Ị",
          "Î",
          "Ï",
          "Ī",
          "Ĭ",
          "Į",
          "İ",
          "Ι",
          "Ί",
          "Ϊ",
          "Ἰ",
          "Ἱ",
          "Ἳ",
          "Ἴ",
          "Ἵ",
          "Ἶ",
          "Ἷ",
          "Ῐ",
          "Ῑ",
          "Ὶ",
          "Ί",
          "И",
          "І",
          "Ї",
          "Ǐ",
          "ϒ",
          "Ｉ",
        ],
        J: ["Ｊ"],
        K: ["К", "Κ", "Ｋ"],
        L: ["Ĺ", "Ł", "Л", "Λ", "Ļ", "Ľ", "Ŀ", "ल", "Ｌ"],
        M: ["М", "Μ", "Ｍ"],
        N: ["Ń", "Ñ", "Ň", "Ņ", "Ŋ", "Н", "Ν", "Ｎ"],
        O: [
          "Ó",
          "Ò",
          "Ỏ",
          "Õ",
          "Ọ",
          "Ô",
          "Ố",
          "Ồ",
          "Ổ",
          "Ỗ",
          "Ộ",
          "Ơ",
          "Ớ",
          "Ờ",
          "Ở",
          "Ỡ",
          "Ợ",
          "Ø",
          "Ō",
          "Ő",
          "Ŏ",
          "Ο",
          "Ό",
          "Ὀ",
          "Ὁ",
          "Ὂ",
          "Ὃ",
          "Ὄ",
          "Ὅ",
          "Ὸ",
          "Ό",
          "О",
          "Θ",
          "Ө",
          "Ǒ",
          "Ǿ",
          "Ｏ",
          "Ö",
        ],
        P: ["П", "Π", "Ｐ"],
        Q: ["Ｑ"],
        R: ["Ř", "Ŕ", "Р", "Ρ", "Ŗ", "Ｒ"],
        S: ["Ş", "Ŝ", "Ș", "Š", "Ś", "С", "Σ", "Ｓ"],
        T: ["Ť", "Ţ", "Ŧ", "Ț", "Т", "Τ", "Ｔ"],
        U: [
          "Ú",
          "Ù",
          "Ủ",
          "Ũ",
          "Ụ",
          "Ư",
          "Ứ",
          "Ừ",
          "Ử",
          "Ữ",
          "Ự",
          "Û",
          "Ū",
          "Ů",
          "Ű",
          "Ŭ",
          "Ų",
          "У",
          "Ǔ",
          "Ǖ",
          "Ǘ",
          "Ǚ",
          "Ǜ",
          "Ｕ",
          "Ў",
          "Ü",
        ],
        V: ["В", "Ｖ"],
        W: ["Ω", "Ώ", "Ŵ", "Ｗ"],
        X: ["Χ", "Ξ", "Ｘ"],
        Y: [
          "Ý",
          "Ỳ",
          "Ỷ",
          "Ỹ",
          "Ỵ",
          "Ÿ",
          "Ῠ",
          "Ῡ",
          "Ὺ",
          "Ύ",
          "Ы",
          "Й",
          "Υ",
          "Ϋ",
          "Ŷ",
          "Ｙ",
        ],
        Z: ["Ź", "Ž", "Ż", "З", "Ζ", "Ｚ"],
        AE: ["Æ", "Ǽ"],
        Ch: ["Ч"],
        Dj: ["Ђ"],
        Dz: ["Џ"],
        Gx: ["Ĝ"],
        Hx: ["Ĥ"],
        Ij: ["Ĳ"],
        Jx: ["Ĵ"],
        Kh: ["Х"],
        Lj: ["Љ"],
        Nj: ["Њ"],
        Oe: ["Œ"],
        Ps: ["Ψ"],
        Sh: ["Ш"],
        Shch: ["Щ"],
        Ss: ["ẞ"],
        Th: ["Þ"],
        Ts: ["Ц"],
        Ya: ["Я"],
        Yu: ["Ю"],
        Zh: ["Ж"],
      };

      Object.keys(swaps).forEach((swap) => {
        swaps[swap].forEach((s) => {
          str = str.replace(new RegExp(s, "g"), swap);
        });
      });
      return (
        str
          .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
          .replace(/\s+/g, "-") // collapse whitespace and replace by -
          //.replace(/-+/g, "-") // collapse dashes
          .replace(/^-+/, "") // trim - from start of text
          .replace(/--+$/, "-")
      );
    },
    colorHex(val) {
      return val == "blue"
        ? "#002f8e"
        : val == "green"
        ? "#008e46"
        : val == "red"
        ? "#8e0000"
        : val == "dark"
        ? "#34495e"
        : val == "purple"
        ? "#6e008e"
        : val == "yellow"
        ? "#c68700"
        : "blue";
    },
    submitChatPage() {
      if (!this.validateForm) return;
      this.$vs.loading();
      if (this.linksList.length == 0) this.finishEditOrCreate();
      else {
        let arrImg = [];
        let fd = new FormData();
        for (var i = 0; i < this.linksList.length; i++) {
          arrImg.push(this.linksList[i].img);
        }
        fd.append("content", arrImg.join("_duotalkparse_"));
        this.$http
          .post("/p/chat/page/" + this.$route.params.chatbot_id + "/img", fd, {
            headers: {
              Authorization: "Bearer " + this.$store.state.auth.accessToken,
              "Content-Type": `multipart/form-data; boundary=${fd._boundary}`,
            },
          })
          .then((response) => {
            let img = response.data.data;
            for (var i = 0; i < img.length; i++)
              if (this.linksList[i] != null) this.linksList[i].img = img[i];

            this.finishEditOrCreate();
          })
          .catch(() => {
            //this.finishEditOrCreate(response);
          });
      }
    },
    finishEditOrCreate() {
      var api_uri = "/p/chat/page";
      if (typeof this.$route.params.chatbot_id !== "undefined")
        api_uri = "/p/chat/page/" + this.$route.params.chatbot_id;

      this.$http({
        method: "post",
        url: api_uri,
        data: {
          title: this.title,
          description: this.description,
          pageName: this.pageName,
          metaTitle: this.metaTitle,
          metaDescription: this.metaDescription,
          linkFacebook: this.FacebookUrl,
          linkInstagram: this.InstagramUrl,
          linkLinkedIn: this.LinkedinUrl,
          linkTwitter: this.TwitterUrl,
          linkYoutube: this.YoutubeUrl,
          linksList: this.linksList,
          color: this.color,
          acc: this.$store.state.acc.current_acc.id,
          chat: this.$route.params.chatbot_id,
        },
      })
        .then((response) => {
          this.$vs.loading.close();
          this.chatPageData = response.data.data;
          this.$store.dispatch(
            "chatbotManagement/fetchChatbot",
            this.$route.params.chatbot_id
          );
          this.$vs.notify({
            title: this.$t("Success"),
            text: this.$t("ChatbotEditedSuccessfuly"),
            iconPack: "feather",
            icon: "icon-success-circle",
            color: "success",
            position: "top-right",
            time: 4000,
          });
          this.changeTab(2);
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (typeof error.request.response !== "undefined")
            error.message =
              JSON.parse(error.request.response).data != null
                ? Array.isArray(JSON.parse(error.request.response).data)
                  ? JSON.parse(error.request.response).data[0].msg
                  : ""
                : JSON.parse(error.request.response).message;
          this.$vs.notify({
            title: this.$t("UnexpectedError"),
            text: error.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            duration: 10000,
            position: "top-right",
            time: 4000,
          });
        });
    },
    changeTab: function (value) {
      this.$emit("input", value);
    },
    postMessageToIframe() {
      const iframe = document.getElementById("chatpage-iframe");
      if (iframe != null) {
        var message = {};
        if (this.chatData.id != null) message.chat = this.chatData.id;
        if (this.title != null) message.title = this.title;
        if (this.description != null) message.description = this.description;
        if (this.chatAvatar != null) message.img = this.chatAvatar;
        if (this.color != null) message.color = this.color;
        message.linkFacebook = this.FacebookUrl;
        message.linkInstagram = this.InstagramUrl;
        message.linkLinkedIn = this.LinkedinUrl;
        message.linkTwitter = this.TwitterUrl;
        message.linkYoutube = this.YoutubeUrl;
        message.linksList = this.linksList;

        iframe.contentWindow.postMessage(message, "*");
      }
    },
    checkChatpageUrl(setSuggestion = false) {
      this.$http({
        method: "GET",
        url:
          "/p/chat/page/checkname?name=" +
          this.pageName +
          "&chat=" +
          this.$route.params.chatbot_id,
        data: {},
      }).then((response) => {
        if (response.data.data.exists === true) {
          if (setSuggestion) this.pageName = response.data.data.suggestion;
          else {
            this.errors.add({
              field: "urlchatpage",
              msg: this.$t("ChatpageNameInUse"),
            });
          }
        }
      });
    },
    setChatpageContent() {
      this.title = this.chatData.chatpage.title || this.chatData.name;
      this.description = this.chatData.chatpage.description || "";
      this.pageName =
        this.chatData.chatpage.pageName ||
        this.chatData.name
          .normalize("NFD")
          .replace(/[^a-zA-Z0-9-]/g, "")
          .toLowerCase();
      this.color =
        this.chatData.chatpage.color || this.colorHex(this.chatData.color);

      this.TwitterUrl = this.chatData.chatpage.linkTwitter;
      this.FacebookUrl = this.chatData.chatpage.linkFacebook;
      this.InstagramUrl = this.chatData.chatpage.linkInstagram;
      this.YoutubeUrl = this.chatData.chatpage.linkYoutube;
      this.LinkedinUrl =
        this.chatData.chatpage.linkLinkedIn ||
        this.chatData.chatpage.linkLinkedin;
      this.linksList = this.chatData.chatpage.linksList || [];

      if (this.chatData.chatpage.pageName != null)
        document.getElementById("button-submit-chatpage").innerHTML =
          this.$t("SaveUpdates");
      this.checkChatpageUrl(true);
    },
    validateSocialURL(e, ref) {
      //event.target.addEventListener("blur", function(e) {
      var val = e.target.value;
      var isUrl =
        /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      if (isUrl.test(val)) {
        val = val.replace("http://", "");
        val = val.replace("https://", "");
        var url = val.split("/");
        if (url[1] != null) {
          url.shift();
          val = url.join("/");
        }
      }
      switch (ref) {
        case "twitter":
          this.TwitterUrl = val;
          break;
        case "instagram":
          this.InstagramUrl = val;
          break;
        case "linkedin":
          this.LinkedinUrl = val;
          break;
        case "facebook":
          this.FacebookUrl = val;
          break;
        case "youtube":
          this.YoutubeUrl = val;
          break;
      }
      //});
    },
  },
  mounted() {
    var self = this;
    if (this.chatData) this.setChatpageContent();
    document
      .getElementById("urlchatpage")
      .addEventListener("input", function (e) {
        var x = self.urlSlang(e.target.value);
        x = x.slice(0, 29);
        self.pageName = x;
      });
    document
      .getElementById("urlchatpage")
      .addEventListener("blur", function () {
        self.checkChatpageUrl(false);
      });
    window.addEventListener(
      "message",
      function (e) {
        if (e.data.ready != null) {
          self.postMessageToIframe();
        }
      },
      false
    );
  },
  watch: {
    title: function () {
      this.postMessageToIframe();
    },
    description: function () {
      this.postMessageToIframe();
    },
    color: function () {
      this.postMessageToIframe();
    },
    YoutubeUrl: function () {
      this.postMessageToIframe();
    },
    InstagramUrl: function () {
      this.postMessageToIframe();
    },
    TwitterUrl: function () {
      this.postMessageToIframe();
    },
    FacebookUrl: function () {
      this.postMessageToIframe();
    },
    LinkedinUrl: function () {
      this.postMessageToIframe();
    },
    linksList: function () {
      this.postMessageToIframe();
    },
    "$store.state.chatbotManagement.current_chatbot": function () {
      this.setChatpageContent();
    },
    newCard: function (val) {
      if (val)
        document.querySelectorAll("#cardslinks div")[2].style.maxHeight = "";
      if (val === false) {
        this.cardTitle = "";
        this.cardLink = "";
        this.imageCard = null;
      }
    },
    editLink: function () {
      document.querySelectorAll("#cardslinks div")[2].style.maxHeight = "";
    },
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    draggable,
    Prism,
    "v-select": vSelect,
    AvatarCropper,
  },
};
</script>

<style lang="scss" scoped>
#cardslinks {
  .vs-collapse-item--header {
    .vs-collapse-item--icon-header {
      top: 20% !important;
    }
  }
}
#preview-chatpage {
  .vs-popup {
    max-width: 100% !important;
    max-height: 100% !important;
  }
  .vs-popup--background {
    background: white !important;
  }
  .vs-popup--content {
    padding: 0 !important;
  }
}
.con-content--item {
  padding: 1rem 0.25rem 1rem 0.25rem !important;
}
#demo-basic-card {
  .overlay-card {
    .vx-card__collapsible-content {
      max-height: 485px;
    }
  }

  .chat-card-log {
    height: 360px;

    .chat-sent-msg {
      background-color: #f2f4f7 !important;
    }
  }

  .card-video {
    .video-js {
      height: 370px;
    }
  }
}
#cb-duotalk {
  height: 550px !important;
}
#chatbot-example {
  max-width: 415px;
  -webkit-box-shadow: 0 0.2px 2px rgba(0, 0, 0, 0.29),
    0 0.5px 4.7px rgba(0, 0, 0, 0.208), 0 0.9px 8.9px rgba(0, 0, 0, 0.173),
    0 1.6px 15.9px rgba(0, 0, 0, 0.145), 0 2.9px 29.7px rgba(0, 0, 0, 0.117),
    0 7px 71px rgba(0, 0, 0, 0.082);

  -moz-box-shadow: 0 0.2px 2px rgba(0, 0, 0, 0.29),
    0 0.5px 4.7px rgba(0, 0, 0, 0.208), 0 0.9px 8.9px rgba(0, 0, 0, 0.173),
    0 1.6px 15.9px rgba(0, 0, 0, 0.145), 0 2.9px 29.7px rgba(0, 0, 0, 0.117),
    0 7px 71px rgba(0, 0, 0, 0.082);

  box-shadow: 0 0.2px 2px rgba(0, 0, 0, 0.29),
    0 0.5px 4.7px rgba(0, 0, 0, 0.208), 0 0.9px 8.9px rgba(0, 0, 0, 0.173),
    0 1.6px 15.9px rgba(0, 0, 0, 0.145), 0 2.9px 29.7px rgba(0, 0, 0, 0.117),
    0 7px 71px rgba(0, 0, 0, 0.082);
}
.preview-btn-chatpage {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
  position: fixed;
  top: 50%;
  z-index: 50000;
  left: -3.4rem;
}
.bg-grey span {
  color: #000 !important;
}
.vs-collapse {
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 30px;
}
.vs-collapse-item--header {
  padding-left: 0px;
  padding-right: 0px;
}
.vs-collapse.default .open-item .con-content--item {
  padding-left: 0px;
  padding-right: 0px;
}

.upgrade-plan-pro {
  position: absolute;

  z-index: 999;
  top: 35px;
}
</style>
